import { useLocalStorage } from '@wistia/vhs';

export const DISMISSED_GUIDANCE_KEY = 'wistia:guidance:dismissed';

export const DismissibleGuidance = {
  RecordEditOnboarding: 'record-edit-onboarding',
  RecordTakeManagementOnboarding: 'record-take-management-onboarding',
  ContentLibraryIntegrationsBanner: 'integrations-funnel-banner-connect',
} as const;

export type DismissibleGuidanceType =
  (typeof DismissibleGuidance)[keyof typeof DismissibleGuidance];

type LocalStorageValue = Partial<Record<DismissibleGuidanceType, boolean>>;
const DefaultLocalStorageValue: LocalStorageValue = {};

export const useDismissibleGuidance = (): {
  isDismissed: (guidanceId: DismissibleGuidanceType) => boolean;
  dismissGuidance: (guidanceId: DismissibleGuidanceType) => void;
} => {
  const [dismissedGuidance, setDismissedGuidance] = useLocalStorage(
    DISMISSED_GUIDANCE_KEY,
    DefaultLocalStorageValue,
  );

  const isDismissed = (guidanceId: DismissibleGuidanceType) =>
    dismissedGuidance?.[guidanceId] === true;
  const dismissGuidance = (guidanceId: DismissibleGuidanceType) =>
    setDismissedGuidance({ ...dismissedGuidance, [guidanceId]: true });

  return {
    isDismissed,
    dismissGuidance,
  };
};
